module.exports = __webpack_public_path__ + "static/media/credit-card (1).def15bf7.svg";